import { assetsQueryConfig } from "./assets/assets.queryConfig";
import { commentThreadsQueryConfig } from "./assets/commentThreads.queryConfig";
import { configurationsQueryConfig } from "./configurations/configurations.queryConfig";
import { entitiesQueryConfig } from "./entities/entities.queryConfig";
import { projectCountsQueryConfig } from "./project/project.counts.queryConfig";
import { projectParticipantsQueryConfig } from "./project/project.participants.queryConfig";
import { projectPermissionsQueryConfig } from "./projects/permissions.queryConfig";
import { projectInvitationsQueryConfig } from "./projects/projectInvitations.queryConfig";
import { registrationQueryConfig } from "./registration/registration.queryConfig";
import { userQueryConfig } from "./user/user.queryConfig";

export default {
  ...assetsQueryConfig,
  ...commentThreadsQueryConfig,
  ...entitiesQueryConfig,
  ...userQueryConfig,
  ...projectPermissionsQueryConfig,
  ...projectInvitationsQueryConfig,
  ...registrationQueryConfig,
  ...projectCountsQueryConfig,
  ...projectParticipantsQueryConfig,
  ...configurationsQueryConfig,
};
